(function ($) {
  'use strict';

  const dev = false; // true | false
  let minimizeElementsTimeout = '';
  let turnMouseFalseTimeOut = '';
  let turnMouseTrueTimeOut = '';
  let mouseOnMenu = false;
  let highestLi = 0;
  const highestLiAddAmt = 10;
  const menuTitle_0 = 'div.field--name-field-menu-text-block';
  const menuDropDown_0 = 'div.menu-dropdown-0';
  const headerSubmenuDomPath = $(`.region-header ul.menu-level-0 li.menu-item ${menuDropDown_0}`);
  const navLinks = $('.region-header ul.menu-level-0 li.menu-item--expanded a');
  const cssJSON = {height: '0', padding: '0', overflow: 'hidden'};
  const fadeClass = 'bbfade';
  const fadeClassAll = 'bb-fade--all';
  const highlightClass = 'highlight';
  const menuOffDelay = 300;
  const menuOnDelay = 175;
  const checkMouseStatusDelay = 300;

  function mouseOverCommon() {
    clearTimeout(minimizeElementsTimeout);
    clearTimeout(turnMouseFalseTimeOut);
  }

  function mouseOutCommon() {
    clearTimeout(turnMouseTrueTimeOut);
    turnMouseFalseTimeOut = setTimeout(function () {
      mouseOnMenu = false;
    }, menuOffDelay);
  }

  function setUlHeight($this = '') {
    highestLi = 0;
    $this.siblings(menuDropDown_0).find('ul.menu-level-1 > li.menu-item').attr('style', '');
    $this.siblings(menuDropDown_0).find('ul.menu-level-1 > li.menu-item').each(function (index, element) {
      if ($(this).height() + highestLiAddAmt > highestLi + highestLiAddAmt) {
        highestLi = $(this).height() + highestLiAddAmt;
      }
    });
    $this.siblings(menuDropDown_0).find('ul.menu-level-1 > li.menu-item').css('height', highestLi);
  }

  function menuContainerChangeWidth($exists, $this) {
    if ($exists) {
      let newWidth = 1240;

      if (window.innerWidth <= 1240) {
        newWidth = window.innerWidth * 0.95;
      }

      $this.siblings(menuDropDown_0).css('width', newWidth);
    }
  }

  // To prevent flashing of menu on page load
  setTimeout(function () {
    headerSubmenuDomPath.addClass(fadeClass);
    navLinks.addClass(fadeClassAll);
    headerSubmenuDomPath.css(cssJSON);
  }, 50);

  $('.region-header ul.menu-level-0 > li.menu-item > a').hover(
    function () {
      // Mouseover
      const $this = $(this);
      navLinks.removeClass(highlightClass);
      $('.region-header ul.menu-level-0 li.menu-item a').removeClass(highlightClass);
      mouseOnMenu = true;

      // Clear timeouts from executing
      mouseOverCommon();

      // Show main nav hover/highlight
      $this.addClass(highlightClass);

      turnMouseTrueTimeOut = setTimeout(function () {
        // Hide all other sub navs
        headerSubmenuDomPath.addClass(window.menuPartHideClass);
        headerSubmenuDomPath.attr('aria-hidden', 'true');
        headerSubmenuDomPath.find(menuTitle_0).addClass(window.menuPartHideClass);

        // Show the sub nav we want
        $this.siblings(menuDropDown_0).attr('style', '');
        $this.siblings(menuDropDown_0).attr('aria-hidden', 'false');
        headerSubmenuDomPath.find('ul.menu-level-1').attr('style', '');
        $this.siblings(menuDropDown_0).removeClass(window.menuPartHideClass);
        $this.siblings(menuDropDown_0).find('ul').removeClass(window.menuPartHideClass);
        $this.siblings(menuDropDown_0).find(menuTitle_0).removeClass(window.menuPartHideClass);
        setUlHeight($this);

        // Make megaMenu Bigger if bg image exists
        menuContainerChangeWidth($this.siblings(menuDropDown_0).find('.field--name-field-mega-menu-accent-image img').length, $this);
      }, menuOnDelay);
    },
    function () {
      // Mouseout
      mouseOutCommon();
    }
  );

  headerSubmenuDomPath.hover(
    function () {
      // Mouseover
      mouseOnMenu = true;

      turnMouseTrueTimeOut = setTimeout(function () {
        mouseOnMenu = true;
        mouseOverCommon();
      }, menuOnDelay);
    },
    function () {
      // Mouseout
      mouseOutCommon();
      mouseOnMenu = false;
    }
  );

  if (dev === false) {
    setInterval(() => {
      if (mouseOnMenu === false) {
        headerSubmenuDomPath.addClass(window.menuPartHideClass);
        navLinks.removeClass(highlightClass);
        minimizeElementsTimeout = setTimeout(function () {
          headerSubmenuDomPath.css(cssJSON);
          headerSubmenuDomPath.attr('aria-hidden', 'true');
          headerSubmenuDomPath.find('ul.menu-level-1').css(cssJSON);
        }, 400);
      }
    }, checkMouseStatusDelay);
  }

})(jQuery);
